import React, { useState, useEffect, useRef } from "react";
import "../styles/AdminPanel.css";
import AdminPasswordForm from "./AdminPasswordForm";
import AdminCharts from "./AdminCharts";
import { useTranslation } from "react-i18next";

import { getApiUrl } from "../utils/config";
const API_URL = getApiUrl();

const Prefs1 = () => {
    const { t } = useTranslation();
    const [isPasswordVerified, setIsPasswordVerified] = useState(false);
    const [withdrawals, setWithdrawals] = useState([]);
    const [payments, setPayments] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const [error, setError] = useState("");

    const [withdrawalPage, setWithdrawalPage] = useState(1);
    const [paymentPage, setPaymentPage] = useState(1);

    const [withdrawalDates, setWithdrawalDates] = useState({ from: "", to: "" });
    const [paymentDates, setPaymentDates] = useState({ from: "01.01.2025", to: "01.01.2026" });

    const [userStats, setUserStats] = useState({ totalUsers: 0, bannedUsers: 0 });
    const [financeStats, setFinanceStats] = useState({ deposits: 0, withdrawals: 0, netProfit: 0 });

    const [referalStats, setReferalStats] = useState({});
    const [userFinanceStats, setUserFinanceStats] = useState({});
    
    // Состояние для статистики бонусов
    const [bonusesStats, setBonusesStats] = useState({
        weeklyCashback: { total_weeks: 0, total_users: 0, total_cashback: 0, total_bonus_burned: 0, avg_cashback_per_user: 0 },
        rakeback: { total_transactions: 0, total_amount: 0, avg_amount: 0 },
        bonusWithdraw: { total_transactions: 0, total_amount: 0, avg_amount: 0 },
        bonusSpent: { total_transactions: 0, total_amount: 0, avg_amount: 0 }
    });
    const [bonusesStatsLoading, setBonusesStatsLoading] = useState(false);
    
    // Состояние для промокодов
    const [promoCodes, setPromoCodes] = useState([]);
    const [promoCodesStats, setPromoCodesStats] = useState([]);
    const [promoPage, setPromoPage] = useState(1);
    const [showPromoForm, setShowPromoForm] = useState(false);
    const [promoFormData, setPromoFormData] = useState({
        code: '',
        expiresAt: '',
        minDeposit: '',
        usageLimit: '',
        perUserLimit: '',
        bonusPercent: '',
        bonusMaxAmount: '',
        freeSpinsCount: '',
        bonusType: 'bonus',
        partnerCode: '',
        conditions: ''
    });
    
    // Состояние для пагинации данных пользователя
    const [userTransactionsPage, setUserTransactionsPage] = useState(1);
    const [userPaymentsPage, setUserPaymentsPage] = useState(1);
    const [userWithdrawalsPage, setUserWithdrawalsPage] = useState(1);
    const [modalTransactionsPage, setModalTransactionsPage] = useState(1);
    const modalTransactionsPerPage = 15;
    
    // Состояние для таблицы всех транзакций
    const [allTransactions, setAllTransactions] = useState([]);
    const [allTransactionsPagination, setAllTransactionsPagination] = useState({});
    const [allTransactionsPage, setAllTransactionsPage] = useState(1);
    const [allTransactionsLoading, setAllTransactionsLoading] = useState(false);
    const [transactionFilters, setTransactionFilters] = useState({
        transaction_type: '',
        currency: '',
        user_id: '',
        date_from: '',
        date_to: '',
        min_amount: '',
        max_amount: ''
    });
    const [availableFilters, setAvailableFilters] = useState({
        transactionTypes: [],
        currencies: []
    });
    
    // Состояние для списка всех пользователей
    const [allUsers, setAllUsers] = useState([]);
    const [allUsersPage, setAllUsersPage] = useState(1);
    const [allUsersPagination, setAllUsersPagination] = useState({ total: 0, totalPages: 0 });
    
    // Фильтры для поиска пользователей
    const [userFilters, setUserFilters] = useState({
        userId: '',
        email: '',
        username: '',
        referrerId: ''
    });
    
    // Изменяем поиск на ID вместо email
    const [userId, setUserId] = useState("");

    // Состояние для верификации
    const [verificationRequests, setVerificationRequests] = useState([]);
    const [verificationPage, setVerificationPage] = useState(1);
    const [verificationStatus, setVerificationStatus] = useState('');
    const [selectedVerificationRequest, setSelectedVerificationRequest] = useState(null);
    const [verificationComment, setVerificationComment] = useState('');
    
    // Состояние для начисления баланса
    const [balanceUsername, setBalanceUsername] = useState('');
    const [balanceAmount, setBalanceAmount] = useState('');
    const [balanceCurrency, setBalanceCurrency] = useState('RUB');
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [balanceResult, setBalanceResult] = useState(null);
    
    // Состояние для изменения реферального процента
    const [referralPercent, setReferralPercent] = useState('');
    const [referralLoading, setReferralLoading] = useState(false);
    const [referralResult, setReferralResult] = useState(null);
    
    // Состояние для CPA партнёрства
    const [cpaPartner, setCpaPartner] = useState(false);
    const [cpaRate, setCpaRate] = useState('');
    const [cpaLoading, setCpaLoading] = useState(false);
    const [cpaResult, setCpaResult] = useState(null);
    const [cpaPartners, setCpaPartners] = useState([]);
    const [selectedCpaPartner, setSelectedCpaPartner] = useState(null);
    const [cpaPartnerDetails, setCpaPartnerDetails] = useState(null);

    // Настройки статистики
    const [selectedCurrency, setSelectedCurrency] = useState('RUB');
    
    // Модалка управления пользователем
    const [manageModalOpen, setManageModalOpen] = useState(false);
    
    // Модалка управления выводом
    const [withdrawalModalOpen, setWithdrawalModalOpen] = useState(false);
    const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
    const [withdrawalComment, setWithdrawalComment] = useState('');
    const [withdrawalProcessing, setWithdrawalProcessing] = useState(false);

    // Refs для навигации по разделам
    const statsRef = useRef(null);
    const usersRef = useRef(null);
    const withdrawalsRef = useRef(null);
    const referralWithdrawalsRef = useRef(null);
    const paymentsRef = useRef(null);
    const verificationRef = useRef(null);
    const promoCodesRef = useRef(null);
    const transactionsRef = useRef(null);
    const cpaPartnersRef = useRef(null);

    // Функция для скролла к разделу
    const scrollToSection = (ref) => {
        ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    useEffect(() => {
        if (!isPasswordVerified) return;
        // Загружаем статистику при старте
            fetchUserStats();
            fetchFinanceStats();
            fetchBonusesStats();
    }, [isPasswordVerified]);

    // Зависимости таблиц, вынесены отдельно
    useEffect(() => {
        if (!isPasswordVerified) return;
        fetchWithdrawals();
    }, [isPasswordVerified, withdrawalPage, withdrawalDates]);

    useEffect(() => {
        if (!isPasswordVerified) return;
        fetchVerificationRequests();
    }, [isPasswordVerified, verificationPage, verificationStatus]);

    useEffect(() => {
        if (!isPasswordVerified) return;
            fetchPayments();
    }, [isPasswordVerified, paymentPage, paymentDates]);

    useEffect(() => {
        if (!isPasswordVerified) return;
        fetchAllTransactions();
    }, [isPasswordVerified, allTransactionsPage, transactionFilters]);

    useEffect(() => {
        if (!isPasswordVerified) return;
        fetchPromoCodes();
        fetchPromoCodesStats();
    }, [isPasswordVerified, promoPage]);


    useEffect(() => {
        if (isPasswordVerified) {
            const loadStats = async () => {
                const statsMap = {};
                for (const w of withdrawals.filter(w => w.type === 'referal')) {
                    if (!w.user_id) continue;
                    statsMap[w.id] = await fetchReferalStats(w.user_id);
                }
                setReferalStats(statsMap);
            };
            if (withdrawals.some(w => w.type === 'referal')) loadStats();
        }
    }, [withdrawals, isPasswordVerified]);

    useEffect(() => {
        if (isPasswordVerified) {
            const loadUserFinanceStats = async () => {
                const statsMap = {};
                for (const w of withdrawals.filter(w => w.type !== 'referal')) {
                    if (!w.user_id || !w.currency) continue;
                    statsMap[w.id] = await fetchUserFinanceStats(w.user_id, w.currency);
                }
                setUserFinanceStats(statsMap);
            };
            if (withdrawals.some(w => w.type !== 'referal')) loadUserFinanceStats();
        }
    }, [withdrawals, isPasswordVerified]);

    // Загрузка списка всех пользователей
    useEffect(() => {
        if (isPasswordVerified) {
            fetchAllUsers();
        }
    }, [allUsersPage, userFilters, isPasswordVerified]);

    // Обновление данных пользователя при изменении пагинации (отключено, т.к. пагинация теперь на фронтенде)
    // useEffect(() => {
    //     if (isPasswordVerified && userInfo) {
    //         fetchUserDetails();
    //     }
    // }, [userTransactionsPage, userPaymentsPage, userWithdrawalsPage]);

    const fetchUserStats = async () => {
        try {
            const res = await fetch(`${API_URL}/api/admin/user-stats`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setUserStats(data);
        } catch {
            console.error("Ошибка загрузки статистики пользователей");
        }
    };

    const fetchFinanceStats = async () => {
        try {
            const res = await fetch(`${API_URL}/api/admin/finance-stats`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setFinanceStats(data);
        } catch {
            console.error("Ошибка загрузки финансовых данных");
        }
    };

    const fetchWithdrawals = async () => {
        try {
            const params = new URLSearchParams({
                page: withdrawalPage,
                from: withdrawalDates.from,
                to: withdrawalDates.to
            });
            const res = await fetch(`${API_URL}/api/admin/withdrawals?${params}`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setWithdrawals(data.withdrawals);
            else setError(data.message);
        } catch {
            setError("Ошибка загрузки заявок");
        }
    };

    const fetchPayments = async () => {
        try {
            const params = new URLSearchParams({
                page: paymentPage,
                from: paymentDates.from,
                to: paymentDates.to
            });

            const res = await fetch(`${API_URL}/api/admin/all-payments?${params}`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setPayments(data.payments);
            else setError(data.message);
        } catch {
            setError("Ошибка загрузки платежей");
        }
    };

    const fetchReferalStats = async (userId) => {
        try {
            const res = await fetch(`${API_URL}/api/admin/referal-stats?userId=${userId}`, { credentials: "include" });
            const data = await res.json();
            if (data.success) return data;
        } catch { }
        return { totalEarnings: {}, alreadyWithdrawn: {}, available: {} };
    };

    const fetchUserFinanceStats = async (userId, currency) => {
        try {
            const res = await fetch(`${API_URL}/api/admin/user-finance-stats?userId=${userId}&currency=${currency}`, { credentials: "include" });
            const data = await res.json();
            if (data.success) return data;
        } catch { }
        return { balance: 0, deposits: 0, withdrawals: 0 };
    };

    const confirmPayment = async (paymentId) => {
        try {
            const res = await fetch(`${API_URL}/api/admin/confirm-payment`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ paymentId })
            });

            const data = await res.json();

            if (data.success) {
                alert(data.message);
                fetchPayments(); // Обновляем список платежей
            } else {
                alert(data.message || "Ошибка при подтверждении платежа");
            }
        } catch {
            alert("Ошибка при подтверждении платежа");
        }
    };

    const fetchUserDetails = async (resetPages = false, targetUserId = null) => {
        const idToFetch = targetUserId || userId;
        if (!idToFetch) return alert("Введите ID пользователя");
        
        if (resetPages) {
            setUserTransactionsPage(1);
            setUserPaymentsPage(1);
            setUserWithdrawalsPage(1);
        }
        
        try {
            const params = new URLSearchParams({
                userId: idToFetch,
                transactionsPage: userTransactionsPage,
                paymentsPage: userPaymentsPage,
                withdrawalsPage: userWithdrawalsPage
            });
            
            const res = await fetch(`${API_URL}/api/admin/user-details?${params}`, {
                credentials: "include"
            });
            const data = await res.json();
            if (data.success) {
                setUserInfo(data);
                setError("");
            } else {
                setUserInfo(null);
                setError(data.message);
            }
        } catch {
            setError("Ошибка загрузки данных пользователя");
            setUserInfo(null);
        }
    };

    const fetchAllUsers = async () => {
        try {
            const params = new URLSearchParams({
                page: allUsersPage,
                limit: 15,
                userId: userFilters.userId,
                email: userFilters.email,
                username: userFilters.username,
                referrerId: userFilters.referrerId
            });
            
            // Убираем пустые параметры
            Object.keys(Object.fromEntries(params)).forEach(key => {
                if (params.get(key) === '') {
                    params.delete(key);
                }
            });
            
            const res = await fetch(`${API_URL}/api/admin/all-users?${params}`, {
                credentials: "include"
            });
            const data = await res.json();
            if (data.success) {
                setAllUsers(data.users);
                setAllUsersPagination(data.pagination);
            }
        } catch (error) {
            console.error("Ошибка загрузки списка пользователей:", error);
        }
    };

    const handleBan = async (targetUserId) => {
        if (!targetUserId) return;
        if (!window.confirm("Забанить пользователя?")) return;
        const res = await fetch(`${API_URL}/api/admin/ban-user`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ userId: parseInt(targetUserId) })
        });
        const data = await res.json();
        if (data.success) {
            alert(data.message);
            fetchAllUsers();
            if (userInfo && userInfo.user.id == targetUserId) {
            fetchUserDetails();
            }
        } else {
            alert(data.message || "Ошибка при бане пользователя");
        }
    };

    const handleUnban = async (targetUserId) => {
        if (!targetUserId) return;
        if (!window.confirm("Разбанить пользователя?")) return;
        const res = await fetch(`${API_URL}/api/admin/unban-user`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ userId: parseInt(targetUserId) })
        });
        const data = await res.json();
        if (data.success) {
            alert(data.message);
            fetchAllUsers();
            if (userInfo && userInfo.user.id == targetUserId) {
            fetchUserDetails();
            }
        } else {
            alert(data.message || "Ошибка при разбане пользователя");
        }
    };

    // Модалка управления пользователем
    const openManageModal = async (id) => {
        setUserId(String(id));
        setModalTransactionsPage(1);
        setReferralPercent('');
        setReferralResult(null);
        setBalanceAmount('');
        setBalanceCurrency('RUB');
        setBalanceResult(null);
        setCpaPartner(false);
        setCpaRate('');
        setCpaResult(null);
        await fetchUserDetails(true, id);
        // Устанавливаем текущие значения CPA из userInfo
        if (userInfo && userInfo.user) {
            setCpaPartner(userInfo.user.cpa_partner || false);
            setCpaRate(userInfo.user.cpa_rate ? String(userInfo.user.cpa_rate) : '');
        }
        setManageModalOpen(true);
    };
    const closeManageModal = () => {
        setManageModalOpen(false);
        setModalTransactionsPage(1);
        setReferralPercent('');
        setReferralResult(null);
        setBalanceAmount('');
        setBalanceResult(null);
    };

    const updateWithdrawalStatus = async (withdrawalId, status, adminComment = '') => {
        setWithdrawalProcessing(true);
        try {
            const res = await fetch(`${API_URL}/api/admin/update-withdrawal`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ withdrawalId, status, adminComment })
            });
            const data = await res.json();
            if (data.success) {
                alert(data.message);
                fetchWithdrawals();
                closeWithdrawalModal();
            } else {
                alert(data.message);
            }
        } catch {
            alert("Ошибка соединения с сервером");
        } finally {
            setWithdrawalProcessing(false);
        }
    };

    // Функции для модального окна вывода
    const openWithdrawalModal = (withdrawal) => {
        setSelectedWithdrawal(withdrawal);
        setWithdrawalComment('');
        setWithdrawalModalOpen(true);
    };

    const closeWithdrawalModal = () => {
        setSelectedWithdrawal(null);
        setWithdrawalComment('');
        setWithdrawalModalOpen(false);
    };

    const handleWithdrawalApprove = () => {
        if (!selectedWithdrawal) return;
        if (!window.confirm(`Подтвердить вывод ${selectedWithdrawal.amount} ${selectedWithdrawal.currency}?`)) return;
        updateWithdrawalStatus(selectedWithdrawal.id, 'SUCCESSFUL', withdrawalComment);
    };

    const handleWithdrawalDeny = () => {
        if (!selectedWithdrawal) return;
        if (!withdrawalComment) {
            alert('Укажите причину отклонения');
            return;
        }
        if (!window.confirm(`Отклонить вывод с комментарием: "${withdrawalComment}"?`)) return;
        updateWithdrawalStatus(selectedWithdrawal.id, 'DENIED', withdrawalComment);
    };

    // Функции для работы с верификацией
    const fetchVerificationRequests = async () => {
        try {
            const params = new URLSearchParams({
                page: verificationPage,
                limit: 20
            });
            if (verificationStatus) {
                params.append('status', verificationStatus);
            }

            const res = await fetch(`${API_URL}/api/admin/verification/requests?${params}`, {
                credentials: "include"
            });
            const data = await res.json();
            if (data.success) {
                setVerificationRequests(data.requests);
            }
        } catch (error) {
            console.error("Ошибка загрузки заявок на верификацию:", error);
        }
    };

    const handleVerificationAction = async (requestId, status, comment = '') => {
        try {
            const res = await fetch(`${API_URL}/api/admin/verification/request/${requestId}/status`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ status, adminComment: comment })
            });
            const data = await res.json();
            if (data.success) {
                alert(data.message);
                setSelectedVerificationRequest(null);
                setVerificationComment('');
                fetchVerificationRequests();
            } else {
                alert(data.message);
            }
        } catch (error) {
            alert("Ошибка при обновлении статуса верификации");
        }
    };

    const openVerificationModal = (request) => {
        setSelectedVerificationRequest(request);
        setVerificationComment('');
    };

    const closeVerificationModal = () => {
        setSelectedVerificationRequest(null);
        setVerificationComment('');
    };

    // Функция для начисления баланса пользователю
    const handleAddBalance = async (usernameOverride = null, currencyOverride = null, amountOverride = null) => {
        const username = usernameOverride || balanceUsername;
        const currency = currencyOverride || balanceCurrency;
        const amount = amountOverride || balanceAmount;

        if (!username || !amount) {
            setBalanceResult({
                success: false,
                message: 'Укажите логин пользователя и сумму'
            });
            return;
        }

        if (isNaN(amount) || parseFloat(amount) <= 0) {
            setBalanceResult({
                success: false,
                message: 'Сумма должна быть положительным числом'
            });
            return;
        }

        if (!window.confirm(`Начислить ${amount} ${currency} пользователю ${username}?`)) {
            return;
        }

        setBalanceLoading(true);
        setBalanceResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/add-balance`, {
                method: 'POST',
                credentials: 'include',
                headers: { 
                    'Content-Type': 'application/json' 
                },
                body: JSON.stringify({
                    username: username,
                    amount: parseFloat(amount),
                    currency: currency,
                    type: 'MANUAL_ADMIN'
                })
            });

            const data = await res.json();

            if (data.success) {
                setBalanceResult({
                    success: true,
                    message: `✅ ${data.message}`,
                    details: `Новый баланс: ${data.data.newBalance.toFixed(2)} ${currency}`
                });
                // Очищаем форму после успешного начисления только если не было override
                if (!usernameOverride) {
                setBalanceUsername('');
                setBalanceAmount('');
                setBalanceCurrency('RUB');
                }
            } else {
                setBalanceResult({
                    success: false,
                    message: `❌ ${data.message}`
                });
            }
        } catch (error) {
            setBalanceResult({
                success: false,
                message: '❌ Ошибка соединения с сервером'
            });
        } finally {
            setBalanceLoading(false);
        }
    };

    // Функция для обновления реферального процента пользователя
    const handleUpdateReferralPercent = async (userId, newPercent) => {
        if (!userId) {
            setReferralResult({
                success: false,
                message: 'Не указан ID пользователя'
            });
            return;
        }

        const percent = parseFloat(newPercent);
        if (isNaN(percent) || percent < 0 || percent > 100) {
            setReferralResult({
                success: false,
                message: 'Процент должен быть числом от 0 до 100'
            });
            return;
        }

        if (!window.confirm(`Установить реферальный процент ${percent}% для пользователя?`)) {
            return;
        }

        setReferralLoading(true);
        setReferralResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/update-referral-percent`, {
                method: 'POST',
                credentials: 'include',
                headers: { 
                    'Content-Type': 'application/json' 
                },
                body: JSON.stringify({
                    userId: userId,
                    referrerPercent: percent
                })
            });

            const data = await res.json();

            if (data.success) {
                setReferralResult({
                    success: true,
                    message: `✅ ${data.message}`
                });
                // Обновляем данные пользователя
                if (userInfo && userInfo.user.id === userId) {
                    fetchUserDetails(false, userId);
                }
            } else {
                setReferralResult({
                    success: false,
                    message: `❌ ${data.message}`
                });
            }
        } catch (error) {
            setReferralResult({
                success: false,
                message: '❌ Ошибка соединения с сервером'
            });
        } finally {
            setReferralLoading(false);
        }
    };

    // Функция для обновления CPA партнёра
    const handleUpdateCPAPartner = async (userId, isPartner, rate) => {
        if (!userId) {
            setCpaResult({
                success: false,
                message: 'Не указан ID пользователя'
            });
            return;
        }

        const cpaRate = rate ? parseFloat(rate) : null;
        if (rate && (isNaN(cpaRate) || cpaRate < 0)) {
            setCpaResult({
                success: false,
                message: 'Ставка должна быть положительным числом'
            });
            return;
        }

        const action = isPartner ? (cpaRate ? `сделать CPA партнёром со ставкой $${cpaRate}` : 'сделать CPA партнёром') : 'убрать статус CPA партнёра';
        if (!window.confirm(`${action} для пользователя?`)) {
            return;
        }

        setCpaLoading(true);
        setCpaResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/cpa-partner/update`, {
                method: 'POST',
                credentials: 'include',
                headers: { 
                    'Content-Type': 'application/json' 
                },
                body: JSON.stringify({
                    userId: userId,
                    cpaPartner: isPartner,
                    cpaRate: cpaRate
                })
            });

            const data = await res.json();

            if (data.success) {
                setCpaResult({
                    success: true,
                    message: `✅ ${data.message}`
                });
                // Обновляем данные пользователя
                if (userInfo && userInfo.user.id === userId) {
                    fetchUserDetails(false, userId);
                }
                // Обновляем список CPA партнёров
                fetchCPAPartners();
            } else {
                setCpaResult({
                    success: false,
                    message: `❌ ${data.message}`
                });
            }
        } catch (error) {
            setCpaResult({
                success: false,
                message: '❌ Ошибка соединения с сервером'
            });
        } finally {
            setCpaLoading(false);
        }
    };

    // Загрузка списка CPA партнёров
    const fetchCPAPartners = async () => {
        try {
            const res = await fetch(`${API_URL}/api/admin/cpa-partners`, {
                credentials: 'include'
            });
            const data = await res.json();
            if (data.success) {
                setCpaPartners(data.partners);
            }
        } catch (error) {
            console.error('Ошибка загрузки CPA партнёров:', error);
        }
    };

    // Загрузка деталей CPA партнёра
    const fetchCPAPartnerDetails = async (partnerId) => {
        try {
            const res = await fetch(`${API_URL}/api/admin/cpa-partner/details?partnerId=${partnerId}`, {
                credentials: 'include'
            });
            const data = await res.json();
            if (data.success) {
                setCpaPartnerDetails(data);
            }
        } catch (error) {
            console.error('Ошибка загрузки деталей CPA партнёра:', error);
        }
    };

    // Загрузка CPA партнёров при загрузке админки
    useEffect(() => {
        if (isPasswordVerified) {
            fetchCPAPartners();
        }
    }, [isPasswordVerified]);

    // Функция для загрузки статистики бонусов
    const fetchBonusesStats = async () => {
        setBonusesStatsLoading(true);
        try {
            const response = await fetch(`${API_URL}/api/admin/bonuses-stats`, {
                method: 'GET',
                credentials: 'include'
            });
            const data = await response.json();
            
            if (data.success) {
                setBonusesStats(data.stats);
            } else {
                console.error('Ошибка загрузки статистики бонусов:', data.message);
            }
        } catch (error) {
            console.error('Ошибка при загрузке статистики бонусов:', error);
        } finally {
            setBonusesStatsLoading(false);
        }
    };

    // Функции для работы с промокодами
    const fetchPromoCodes = async () => {
        try {
            const res = await fetch(`${API_URL}/api/promo/all?page=${promoPage}`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setPromoCodes(data.promoCodes);
        } catch (error) {
            console.error("Ошибка загрузки промокодов:", error);
        }
    };

    const fetchPromoCodesStats = async () => {
        try {
            const res = await fetch(`${API_URL}/api/promo/stats`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setPromoCodesStats(data.stats);
        } catch (error) {
            console.error("Ошибка при загрузке статистики промокодов:", error);
        }
    };

    const handlePromoFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_URL}/api/promo/create`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(promoFormData)
            });
            const data = await res.json();
            if (data.success) {
                alert("Промокод создан успешно!");
                setShowPromoForm(false);
                setPromoFormData({
                    code: '',
                    expiresAt: '',
                    minDeposit: '',
                    usageLimit: '',
                    perUserLimit: '',
                    bonusPercent: '',
                    bonusMaxAmount: '',
                    freeSpinsCount: '',
                    bonusType: 'bonus',
                    partnerCode: '',
                    conditions: ''
                });
                fetchPromoCodes();
                fetchPromoCodesStats();
            } else {
                alert("Ошибка при создании промокода: " + data.message);
            }
        } catch (error) {
            console.error("Ошибка при создании промокода:", error);
            alert("Ошибка при создании промокода");
        }
    };

    const handlePromoAction = async (promoId, action) => {
        try {
            const res = await fetch(`${API_URL}/api/promo/${promoId}/${action}`, {
                method: 'POST',
                credentials: 'include'
            });
            const data = await res.json();
            if (data.success) {
                alert(`Промокод ${action === 'activate' ? 'активирован' : action === 'deactivate' ? 'деактивирован' : 'удален'}!`);
                fetchPromoCodes();
                fetchPromoCodesStats();
            } else {
                alert("Ошибка: " + data.message);
            }
        } catch (error) {
            console.error("Ошибка при выполнении действия:", error);
            alert("Ошибка при выполнении действия");
        }
    };

    // Функция для загрузки всех транзакций
    const fetchAllTransactions = async () => {
        setAllTransactionsLoading(true);
        try {
            const queryParams = new URLSearchParams({
                page: allTransactionsPage,
                limit: 15,
                ...transactionFilters
            });
            
            // Убираем пустые параметры
            Object.keys(queryParams).forEach(key => {
                if (queryParams.get(key) === '') {
                    queryParams.delete(key);
                }
            });

            const response = await fetch(`${API_URL}/api/admin/transactions?${queryParams}`, {
                method: 'GET',
                credentials: 'include'
            });
            const data = await response.json();
            
            if (data.success) {
                setAllTransactions(data.transactions);
                setAllTransactionsPagination(data.pagination);
                setAvailableFilters(data.filters);
            } else {
                console.error('Ошибка загрузки транзакций:', data.message);
            }
        } catch (error) {
            console.error('Ошибка при загрузке транзакций:', error);
        } finally {
            setAllTransactionsLoading(false);
        }
    };

    // Функция для сброса фильтров
    const resetTransactionFilters = () => {
        setTransactionFilters({
            transaction_type: '',
            currency: '',
            user_id: '',
            date_from: '',
            date_to: '',
            min_amount: '',
            max_amount: ''
        });
        setAllTransactionsPage(1);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '—';
        return new Date(dateString).toLocaleString('ru-RU');
    };

    if (!isPasswordVerified) {
        return <AdminPasswordForm onPasswordCorrect={() => setIsPasswordVerified(true)} />;
    }

    return (
        <div className="prefs-admin-container">
            <h1>Админ-панель - Часть 1</h1>

            {/* Навигация по разделам */}
            <div style={{ 
                position: 'sticky', 
                top: 0, 
                zIndex: 100, 
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)', 
                padding: '15px 20px', 
                borderRadius: '12px',
                marginBottom: '20px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                display: 'flex',
                gap: '10px',
                flexWrap: 'wrap',
                alignItems: 'center'
            }}>
                <span style={{ fontWeight: 700, color: '#fff', marginRight: '10px', fontSize: '14px' }}>🔖 Разделы:</span>
                <button onClick={() => scrollToSection(statsRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    📊 Статистика
                </button>
                <button onClick={() => scrollToSection(usersRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    👥 Пользователи
                </button>
                <button onClick={() => scrollToSection(withdrawalsRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    💸 Выводы
                </button>
                <button onClick={() => scrollToSection(referralWithdrawalsRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    🤝 Выводы реф.
                </button>
                <button onClick={() => scrollToSection(paymentsRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    💳 Платежи
                </button>
                <button onClick={() => scrollToSection(verificationRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    ✅ Верификация
                </button>
                <button onClick={() => scrollToSection(promoCodesRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    🎟️ Промокоды
                </button>
                <button onClick={() => scrollToSection(transactionsRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    📋 Транзакции
                </button>
                <button onClick={() => scrollToSection(cpaPartnersRef)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'transform 0.2s' }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                    💼 CPA Партнёры
                </button>
            </div>

            {/* Общая статистика */}
            <div ref={statsRef} className="prefs-section">
                <AdminCharts 
                    bonusesStats={bonusesStats} 
                    bonusesStatsLoading={bonusesStatsLoading}
                    selectedCurrency={selectedCurrency}
                    setSelectedCurrency={setSelectedCurrency}
                    userStats={userStats}
                    financeStats={financeStats}
                />
            </div>

            {/* Единый блок управления пользователями */}
            <div ref={usersRef} className="prefs-section">
                <h2>Управление пользователями</h2>

                {/* Модалка управления пользователем на весь экран */}
                {manageModalOpen && userInfo && (
                    <div className="user-modal-overlay" onClick={closeManageModal}>
                        <div className="user-modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="user-modal-header">
                                <h2>Управление пользователем</h2>
                                <button onClick={closeManageModal} className="user-modal-close">✕ Закрыть</button>
                            </div>

                            {/* Информация о пользователе */}
                            <div className="user-info-grid">
                                <div className="user-info-card user-info-card-basic">
                                    <h3>📋 Основная информация</h3>
                                    <div className="user-info-fields">
                                        <div><strong>ID:</strong> {userInfo.user.id}</div>
                                        <div><strong>Email:</strong> {userInfo.user.email} {userInfo.user.email_verified ? '✅' : '❌'}</div>
                                        <div><strong>Username:</strong> {userInfo.user.username || '—'}</div>
                                        <div><strong>Телефон:</strong> {userInfo.user.phone_number || '—'}</div>
                                        <div><strong>Telegram:</strong> {userInfo.user.telegram || '—'} {userInfo.user.telegram_id ? `(ID: ${userInfo.user.telegram_id})` : ''}</div>
                                        <div><strong>Страна:</strong> {userInfo.user.country || '—'} (Рег: {userInfo.user.registration_country || '—'})</div>
                                        <div><strong>Статус:</strong> {userInfo.user.banned ? '❌ Забанен' : '✅ Активен'}</div>
                                        <div><strong>Верификация:</strong> {
                                            userInfo.user.verification_status === 'approved' ? '✅ Одобрена' :
                                            userInfo.user.verification_status === 'pending' ? '⏳ На рассмотрении' :
                                            userInfo.user.verification_status === 'rejected' ? '❌ Отклонена' : '—'
                                        }</div>
                                    </div>
                                    <div className="user-action-buttons">
                                        {!userInfo.user.banned && (
                                            <button onClick={() => handleBan(userInfo.user.id)} className="btn-danger">🚫 Забанить</button>
                                        )}
                                        {userInfo.user.banned && (
                                            <button onClick={() => handleUnban(userInfo.user.id)} className="btn-success">✅ Разбанить</button>
                                        )}
                                    </div>
                                </div>

                                <div className="user-info-card user-info-card-balance">
                                    <h3>💰 Основные балансы</h3>
                                    <div className="user-info-fields">
                                        <div><strong>USD:</strong> ${parseFloat(userInfo.user.balance_usd || 0).toFixed(2)}</div>
                                        <div><strong>RUB:</strong> ₽{parseFloat(userInfo.user.balance_rub || 0).toFixed(2)}</div>
                                        <div><strong>BRL:</strong> R${parseFloat(userInfo.user.balance_brl || 0).toFixed(2)}</div>
                                        <div><strong>USDT:</strong> ₮{parseFloat(userInfo.user.balance_usdt || 0).toFixed(2)}</div>
                                        <div><strong>EUR:</strong> €{parseFloat(userInfo.user.balance_eur || 0).toFixed(2)}</div>
                                    </div>
                                    {userInfo.balanceCheck && userInfo.balanceCheck.hasDiscrepancies && (
                                        <div className="balance-warning">⚠️ Обнаружены расхождения!</div>
                                    )}
                                    {userInfo.balanceCheck && !userInfo.balanceCheck.hasDiscrepancies && (
                                        <div className="balance-success">✅ Балансы в порядке</div>
                                    )}
                                </div>

                                <div className="user-info-card user-info-card-bonus">
                                    <h3>🎁 Бонусные балансы</h3>
                                    <div className="user-info-fields">
                                        <div><strong>USD:</strong> ${parseFloat(userInfo.user.bonus_balance_usd || 0).toFixed(2)}</div>
                                        <div><strong>RUB:</strong> ₽{parseFloat(userInfo.user.bonus_balance_rub || 0).toFixed(2)}</div>
                                        <div><strong>BRL:</strong> R${parseFloat(userInfo.user.bonus_balance_brl || 0).toFixed(2)}</div>
                                        <div><strong>USDT:</strong> ₮{parseFloat(userInfo.user.bonus_balance_usdt || 0).toFixed(2)}</div>
                                        <div><strong>EUR:</strong> €{parseFloat(userInfo.user.bonus_balance_eur || 0).toFixed(2)}</div>
                                    </div>
                                </div>

                                <div className="user-info-card user-info-card-stats">
                                    <h3>🎮 Игровая статистика</h3>
                                    <div className="user-info-fields">
                                        <div><strong>Фриспины:</strong> {userInfo.user.freespins || 0}</div>
                                        <div><strong>Опыт:</strong> {userInfo.user.experience_points || 0}</div>
                                        <div><strong>Его % от рефералов:</strong> <span style={{color: '#28bc10', fontWeight: 'bold'}}>{userInfo.user.ref_percent}%</span></div>
                                        <div><strong>Реферер ID:</strong> {userInfo.user.referrer_id || '—'}</div>
                                        <div><strong>% его реферера:</strong> <span style={{color: '#ff9800', fontWeight: 'bold'}}>{userInfo.user.referrer_percent}%</span></div>
                                        <div><strong>CPA партнёр:</strong> {userInfo.user.cpa_partner ? <span style={{color: '#28bc10', fontWeight: 'bold'}}>✓ Да (${userInfo.user.cpa_rate || 0})</span> : <span style={{color: '#999'}}>Нет</span>}</div>
                                        <div><strong>CPA партнёр ID:</strong> {userInfo.user.cpa_partner_id || '—'}</div>
                                    </div>
                                </div>
                            </div>

                            {/* Управление реферальным процентом */}
                            <div className="add-balance-section">
                                <h3>🤝 Реферальный процент</h3>
                                <p style={{ fontSize: '13px', marginBottom: '10px', color: '#999' }}>
                                    Процент который пользователь получает с потерь своих рефералов
                                </p>
                                <div className="add-balance-grid">
                                    <input
                                        type="number"
                                        className="prefs-input"
                                        value={referralPercent}
                                        placeholder={`Текущий: ${userInfo.user.ref_percent}%`}
                                        onChange={(e) => setReferralPercent(e.target.value)}
                                        min="0"
                                        max="100"
                                        step="0.1"
                                    />
                                    <button
                                        onClick={() => handleUpdateReferralPercent(userInfo.user.id, referralPercent)}
                                        disabled={referralLoading || !referralPercent}
                                        className={referralLoading || !referralPercent ? '' : 'btn-success'}
                                    >
                                        {referralLoading ? '⏳ Обновление...' : '🤝 Установить процент'}
                                    </button>
                                </div>
                                {referralResult && (
                                    <div className={`add-balance-result ${referralResult.success ? 'add-balance-result-success' : 'add-balance-result-error'}`}>
                                        <div className="font-bold">{referralResult.message}</div>
                                    </div>
                                )}
                            </div>

                            {/* Управление CPA партнёрством */}
                            <div className="add-balance-section">
                                <h3>💼 CPA Партнёрство</h3>
                                <p style={{ fontSize: '13px', marginBottom: '10px', color: '#999' }}>
                                    Сделать пользователя CPA партнёром и установить ставку выплаты за каждого пользователя с депозитом
                                </p>
                                <div style={{ marginBottom: '10px' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={cpaPartner}
                                            onChange={(e) => {
                                                setCpaPartner(e.target.checked);
                                                if (!e.target.checked) {
                                                    setCpaRate('');
                                                }
                                            }}
                                        />
                                        <span>Сделать CPA партнёром</span>
                                    </label>
                                </div>
                                {cpaPartner && (
                                    <div className="add-balance-grid">
                                        <input
                                            type="number"
                                            className="prefs-input"
                                            value={cpaRate}
                                            placeholder={`Текущая ставка: $${userInfo.user.cpa_rate || 0}`}
                                            onChange={(e) => setCpaRate(e.target.value)}
                                            min="0"
                                            step="0.01"
                                        />
                                        <button
                                            onClick={() => handleUpdateCPAPartner(userInfo.user.id, true, cpaRate)}
                                            disabled={cpaLoading || !cpaRate}
                                            className={cpaLoading || !cpaRate ? '' : 'btn-success'}
                                        >
                                            {cpaLoading ? '⏳ Обновление...' : '💼 Установить CPA партнёрство'}
                                        </button>
                                    </div>
                                )}
                                {!cpaPartner && userInfo.user.cpa_partner && (
                                    <button
                                        onClick={() => handleUpdateCPAPartner(userInfo.user.id, false, null)}
                                        disabled={cpaLoading}
                                        className={cpaLoading ? '' : 'btn-danger'}
                                        style={{ marginTop: '10px' }}
                                    >
                                        {cpaLoading ? '⏳ Обновление...' : '❌ Убрать статус CPA партнёра'}
                                    </button>
                                )}
                                {cpaResult && (
                                    <div className={`add-balance-result ${cpaResult.success ? 'add-balance-result-success' : 'add-balance-result-error'}`}>
                                        <div className="font-bold">{cpaResult.message}</div>
                                    </div>
                                )}
                            </div>
                
                {/* Начисление баланса */}
                            <div className="add-balance-section">
                                <h3>💰 Начислить баланс</h3>
                                <div className="add-balance-grid">
                        <input
                            type="number"
                                        className="prefs-input"
                            value={balanceAmount}
                                        placeholder="Сумма"
                            onChange={(e) => setBalanceAmount(e.target.value)}
                            min="0.01"
                            step="0.01"
                            />
                        <select
                            value={balanceCurrency}
                            onChange={(e) => setBalanceCurrency(e.target.value)}
                                        className="prefs-input"
                        >
                            <option value="RUB">₽ RUB</option>
                            <option value="USD">$ USD</option>
                            <option value="BRL">R$ BRL</option>
                                        <option value="USDT">₮ USDT</option>
                            <option value="EUR">€ EUR</option>
                        </select>
                        <button
                                        onClick={() => handleAddBalance(userInfo.user.email, balanceCurrency, balanceAmount)}
                                        disabled={balanceLoading || !balanceAmount}
                                        className={balanceLoading || !balanceAmount ? '' : 'btn-success'}
                        >
                                {balanceLoading ? '⏳ Начисление...' : '💰 Начислить'}
                        </button>
                    </div>
                {balanceResult && (
                                    <div className={`add-balance-result ${balanceResult.success ? 'add-balance-result-success' : 'add-balance-result-error'}`}>
                                        <div className="font-bold">{balanceResult.message}</div>
                                        {balanceResult.details && <div className="details">{balanceResult.details}</div>}
                    </div>
                )}
            </div>

                            {/* Таблица транзакций с пагинацией */}
                            <h3 className="transactions-title">📊 Последние транзакции</h3>
                            {(() => {
                                const totalTransactions = userInfo.transactions.length;
                                const totalPages = Math.ceil(totalTransactions / modalTransactionsPerPage);
                                const startIndex = (modalTransactionsPage - 1) * modalTransactionsPerPage;
                                const endIndex = startIndex + modalTransactionsPerPage;
                                const paginatedTransactions = userInfo.transactions.slice(startIndex, endIndex);

                                return (
                                    <>
                                        <div className="transaction-info">
                                            Показано {paginatedTransactions.length} из {totalTransactions} транзакций
                        </div>
                                        <div className="prefs-table-wrapper">
                                            <table className="prefs-table">
                                <thead>
                                        <tr><th>ID</th><th>Дата</th><th>Сумма</th><th>Валюта</th><th>Новый баланс</th><th>Тип</th></tr>
                                </thead>
                                <tbody>
                                                    {paginatedTransactions.map((tx) => (
                                        <tr key={tx.id}>
                                            <td>{tx.id}</td>
                                            <td>{new Date(tx.created_at).toLocaleString('ru-RU')}</td>
                                                            <td className={tx.amount >= 0 ? 'transaction-amount-positive' : 'transaction-amount-negative'}>{tx.amount >= 0 ? '+' : ''}{parseFloat(tx.amount).toFixed(2)}</td>
                                            <td>{tx.currency}</td>
                                            <td>{parseFloat(tx.new_balance).toFixed(2)}</td>
                                            <td>{tx.transaction_type}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                                        {totalPages > 1 && (
                                            <div className="pagination-controls">
                                                <button 
                                                    onClick={() => setModalTransactionsPage(Math.max(1, modalTransactionsPage - 1))}
                                                    disabled={modalTransactionsPage === 1}
                                                >
                                                    ← Предыдущая
                                                </button>
                                                <span>
                                                    Страница {modalTransactionsPage} из {totalPages}
                                                </span>
                                                <button 
                                                    onClick={() => setModalTransactionsPage(Math.min(totalPages, modalTransactionsPage + 1))}
                                                    disabled={modalTransactionsPage === totalPages}
                                                >
                                                    Следующая →
                                                </button>
                            </div>
                                        )}
                                    </>
                                );
                            })()}
                        </div>
                            </div>
                        )}

                {/* Список всех пользователей */}
                <div className="prefs-table-wrapper user-search-wrapper">
                    <h3 style={{ marginBottom: 20 }}>🔍 Фильтры поиска пользователей</h3>
                    <div className="filter-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: 20 }}>
                        <div className="filter-item">
                            <label style={{ display: 'block', marginBottom: 5, fontSize: 13, color: '#999' }}>ID пользователя:</label>
                            <input
                                type="number"
                                className="prefs-input"
                                value={userFilters.userId}
                                placeholder="Например: 123"
                                onChange={(e) => {
                                    setUserFilters({...userFilters, userId: e.target.value});
                                    setAllUsersPage(1);
                                }}
                            />
                        </div>
                        <div className="filter-item">
                            <label style={{ display: 'block', marginBottom: 5, fontSize: 13, color: '#999' }}>Email:</label>
                        <input
                            type="text"
                            className="prefs-input"
                                value={userFilters.email}
                                placeholder="Например: user@mail.com"
                            onChange={(e) => {
                                    setUserFilters({...userFilters, email: e.target.value});
                                setAllUsersPage(1);
                            }}
                            />
                        </div>
                        <div className="filter-item">
                            <label style={{ display: 'block', marginBottom: 5, fontSize: 13, color: '#999' }}>Username:</label>
                            <input
                                type="text"
                                className="prefs-input"
                                value={userFilters.username}
                                placeholder="Например: username"
                                onChange={(e) => {
                                    setUserFilters({...userFilters, username: e.target.value});
                                    setAllUsersPage(1);
                                }}
                            />
                        </div>
                        <div className="filter-item">
                            <label style={{ display: 'block', marginBottom: 5, fontSize: 13, color: '#999' }}>ID реферера:</label>
                            <input
                                type="number"
                                className="prefs-input"
                                value={userFilters.referrerId}
                                placeholder="Например: 456"
                                onChange={(e) => {
                                    setUserFilters({...userFilters, referrerId: e.target.value});
                                    setAllUsersPage(1);
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
                        <button 
                            onClick={() => {
                                setUserFilters({userId: '', email: '', username: '', referrerId: ''});
                                setAllUsersPage(1);
                            }}
                            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#ff4444', color: '#fff', cursor: 'pointer', fontWeight: 600 }}
                        >
                            🗑️ Сбросить фильтры
                        </button>
                    </div>
                    <div className="transaction-info" style={{ textAlign: 'center', marginBottom: 15 }}>
                        {Object.values(userFilters).some(v => v !== '') ? (
                            <>Найдено пользователей: <strong>{allUsersPagination.total || 0}</strong></>
                        ) : (
                            <>Всего пользователей: <strong>{allUsersPagination.total || 0}</strong></>
                        )}
                    </div>
                            {allUsers.length === 0 && Object.values(userFilters).some(v => v !== '') ? (
                                <div className="alert alert-info" style={{ textAlign: 'center', marginTop: 20 }}>
                                    <p style={{ margin: 0 }}>📭 Пользователи не найдены</p>
                                    <p style={{ margin: '5px 0 0 0', fontSize: 13 }}>Попробуйте изменить фильтры</p>
                                </div>
                            ) : (
                            <table className="prefs-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                <th>Email</th>
                                <th>Username</th>
                                <th>Страна</th>
                                <th>Балансы</th>
                                        <th>Валюта</th>
                                        <th>Реферер ID</th>
                                <th>Роль</th>
                                        <th>Статус</th>
                                <th>Действия</th>
                                <th>Дата регистрации</th>
                                    </tr>
                                </thead>
                                <tbody>
                            {allUsers.map((user) => (
                                <tr key={user.id}>
                                    <td>{user.id}</td>
                                    <td>{user.email}{user.email_verified && ' ✅'}{user.telegram_id && ' 📱'}</td>
                                    <td>{user.username || '—'}</td>
                                    <td>{user.country || user.registration_country || '—'}</td>
                                    <td>
                                        <div className="font-size-sm">
                                            {parseFloat(user.balance_usd || 0) > 0 && <div>💵 ${parseFloat(user.balance_usd).toFixed(2)}</div>}
                                            {parseFloat(user.balance_rub || 0) > 0 && <div>₽ {parseFloat(user.balance_rub).toFixed(2)}</div>}
                                            {parseFloat(user.balance_brl || 0) > 0 && <div>R$ {parseFloat(user.balance_brl).toFixed(2)}</div>}
                                            {parseFloat(user.balance_usdt || 0) > 0 && <div>₮ {parseFloat(user.balance_usdt).toFixed(2)}</div>}
                                            {parseFloat(user.balance_eur || 0) > 0 && <div>€ {parseFloat(user.balance_eur).toFixed(2)}</div>}
                                            {parseFloat(user.balance_usd || 0) === 0 && 
                                             parseFloat(user.balance_rub || 0) === 0 && 
                                             parseFloat(user.balance_brl || 0) === 0 && 
                                             parseFloat(user.balance_usdt || 0) === 0 && 
                                             parseFloat(user.balance_eur || 0) === 0 && '—'}
                                        </div>
                                    </td>
                                    <td>{user.selected_currency}</td>
                                    <td>
                                        {user.referrer_id ? (
                                            <span style={{color: '#28bc10', fontWeight: 'bold', cursor: 'pointer'}} 
                                                  onClick={() => {
                                                      setUserFilters({userId: user.referrer_id.toString(), email: '', username: '', referrerId: ''});
                                                      setAllUsersPage(1);
                                                  }}
                                                  title="Кликните чтобы найти реферера">
                                                🔗 {user.referrer_id}
                                            </span>
                                        ) : '—'}
                                    </td>
                                    <td>{user.role === 'admin' ? '👑 Админ' : (user.role === 'user' ? 'Игрок' : user.role)}</td>
                                    <td>{user.banned ? '❌ Забанен' : '✅ Активен'}</td>
                                    <td>
                                        <button onClick={() => openManageModal(user.id)}>⚙️ Управлять</button>
                                    </td>
                                    <td>{new Date(user.created_at).toLocaleDateString('ru-RU')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            )}
                            {allUsers.length > 0 && (
                                <div className="mt-10">
                                <button 
                            onClick={() => setAllUsersPage(Math.max(1, allUsersPage - 1))}
                            disabled={allUsersPage === 1}
                                >
                                    ← Назад
                                </button>
                                    <span className="m-0-10">
                            Страница {allUsersPage} из {allUsersPagination.totalPages || 1}
                                </span>
                                <button 
                            onClick={() => setAllUsersPage(allUsersPage + 1)}
                            disabled={allUsersPage >= allUsersPagination.totalPages}
                                >
                                    Вперед →
                                </button>
                            </div>
                            )}
                </div>
            </div>

            <div ref={withdrawalsRef} className="prefs-section">
                <h2>Фильтр выводов</h2>
                <input type="date" className="prefs-input" value={withdrawalDates.from} onChange={e => setWithdrawalDates({ ...withdrawalDates, from: e.target.value })} />
                <input type="date" className="prefs-input" value={withdrawalDates.to} onChange={e => setWithdrawalDates({ ...withdrawalDates, to: e.target.value })} />
                <button onClick={() => setWithdrawalPage(1)}>Обновить</button>

                <div className="prefs-table-wrapper">
                    <table className="prefs-table">
                        <thead>
                            <tr><th>Действия</th><th>ID</th><th>Email</th><th>Сумма</th><th>Валюта</th><th>Реквизиты</th><th>Банк</th><th>Метод</th><th>ФИО</th><th>Статус</th><th>Дата</th><th>Баланс</th><th>Депозиты</th><th>Выводы</th></tr>
                        </thead>
                        <tbody>
                            {withdrawals.filter(w => w.type !== 'referal').map(w => {
                                const stats = userFinanceStats[w.id] || { balance: 0, deposits: 0, withdrawals: 0 };
                                const requisites = [w.phone_number, w.card_number, w.wallet].filter(Boolean).join('\n');
                                return (
                                    <tr key={w.id}>
                                        <td>
                                            <button onClick={() => openWithdrawalModal(w)} style={{ whiteSpace: 'nowrap' }}>
                                                ⚙️ Управлять
                                            </button>
                                        </td>
                                        <td>
                                            {w.id}
                                            {w.user_email && (
                                                <div className="text-gray-400">{w.user_email}</div>
                                            )}
                                        </td>
                                        <td>{w.user_email}</td>
                                        <td>{w.amount}</td>
                                        <td>{w.currency}</td>
                                        <td className="whitespace-pre-line">
                                            {w.phone_number && <div>📱 {w.phone_number}</div>}
                                            {w.card_number && <div>💳 {w.card_number}</div>}
                                            {w.wallet && <div>👛 {w.wallet}</div>}
                                            {!(w.phone_number || w.card_number || w.wallet) && '—'}
                                        </td>
                                        <td>{w.bank_name || "—"}</td>
                                        <td>{w.payment_method || "—"}</td>
                                        <td>{w.fio || "—"}</td>
                                        <td>
                                            <span className={`status-${w.status.toLowerCase()}`}>{w.status}</span>
                                            {w.admin_comment && (
                                                <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }} title={w.admin_comment}>
                                                    💬 {w.admin_comment.substring(0, 30)}{w.admin_comment.length > 30 ? '...' : ''}
                                                </div>
                                            )}
                                        </td>
                                        <td>{new Date(w.created_at).toLocaleString()}</td>
                                        <td>{stats.balance.toFixed(2)}</td>
                                        <td>{stats.deposits.toFixed(2)}</td>
                                        <td>{stats.withdrawals.toFixed(2)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <button onClick={() => setWithdrawalPage(Math.max(1, withdrawalPage - 1))}>Пред</button>
                <span>Страница {withdrawalPage}</span>
                <button onClick={() => setWithdrawalPage(withdrawalPage + 1)}>След</button>
            </div>

            <div ref={referralWithdrawalsRef} className="prefs-section">
                <h2>Выводы рефералов</h2>
                <div className="prefs-table-wrapper">
                    <table className="prefs-table">
                        <thead>
                            <tr><th>Действия</th><th>ID</th><th>Реквизиты</th><th>Банк</th><th>Метод</th><th>ФИО</th><th>Статус</th><th>Дата</th><th>Реф. доход</th><th>Сумма</th><th>Валюта</th></tr>
                        </thead>
                        <tbody>
                            {withdrawals.filter(w => w.type === 'referal').map(w => {
                                const stats = referalStats[w.id] || { totalEarnings: {}, alreadyWithdrawn: {}, available: {} };
                                const currencies = Object.keys(stats.totalEarnings || {});
                                const refIncomeCell = currencies.length > 0 ? currencies.map(cur => {
                                    let symbol = cur;
                                    if (cur === 'RUB') symbol = '₽';
                                    else if (cur === 'USD') symbol = '$';
                                    else if (cur === 'BRL') symbol = 'R$';
                                    else if (cur === 'USDT') symbol = '₮';
                                    else if (cur === 'EUR') symbol = '€';
                                    return (
                                        <div key={cur}>
                                            <span className="status-successful font-bold">{Number(stats.totalEarnings[cur] || 0).toFixed(2)}</span>
                                            <span className="text-gray-400 font-bold">/</span>
                                            <span className="status-pending font-bold">{Number(stats.alreadyWithdrawn[cur] || 0).toFixed(2)}</span>
                                            <span className="text-gray-400 font-bold">/</span>
                                            <span className="status-clientpaid font-bold">{Number(stats.available[cur] || 0).toFixed(2)}</span>
                                            <span className="text-gray-400 font-bold ml-1">{symbol}</span>
                                        </div>
                                    );
                                }) : '—';
                                return (
                                    <tr key={w.id}>
                                        <td>
                                            <button onClick={() => openWithdrawalModal(w)} style={{ whiteSpace: 'nowrap' }}>
                                                ⚙️ Управлять
                                            </button>
                                        </td>
                                        <td>
                                            {w.id}
                                            {w.user_email && (
                                                <div className="text-gray-400">{w.user_email}</div>
                                            )}
                                        </td>
                                        <td className="whitespace-pre-line">
                                            {w.phone_number && <div>📱 {w.phone_number}</div>}
                                            {w.card_number && <div>💳 {w.card_number}</div>}
                                            {w.wallet && <div>👛 {w.wallet}</div>}
                                            {!(w.phone_number || w.card_number || w.wallet) && '—'}
                                        </td>
                                        <td>{w.bank_name || "—"}</td>
                                        <td>{w.payment_method || "—"}</td>
                                        <td>{w.fio || "—"}</td>
                                        <td>
                                            <span className={`status-${w.status.toLowerCase()}`}>{w.status}</span>
                                            {w.admin_comment && (
                                                <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }} title={w.admin_comment}>
                                                    💬 {w.admin_comment.substring(0, 30)}{w.admin_comment.length > 30 ? '...' : ''}
                                                </div>
                                            )}
                                        </td>
                                        <td>{new Date(w.created_at).toLocaleString()}</td>
                                        <td className="whitespace-pre-line">{refIncomeCell}</td>
                                        <td>{w.amount}</td>
                                        <td>{w.currency}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Модальное окно для управления выводом */}
            {withdrawalModalOpen && selectedWithdrawal && (
                <div className="user-modal-overlay" onClick={closeWithdrawalModal}>
                    <div className="user-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px' }}>
                        <div className="user-modal-header">
                            <h2>Управление заявкой на вывод #{selectedWithdrawal.id}</h2>
                            <button onClick={closeWithdrawalModal} className="user-modal-close">✕ Закрыть</button>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                            {/* Информация о выводе */}
                            <div className="user-info-card">
                                <h3>💸 Информация о выводе</h3>
                                <div className="user-info-fields">
                                    <div><strong>ID заявки:</strong> {selectedWithdrawal.id}</div>
                                    <div><strong>Тип:</strong> {selectedWithdrawal.type === 'referal' ? '🤝 Реферальный' : '💰 Обычный'}</div>
                                    <div><strong>Сумма:</strong> <span style={{fontSize: '18px', fontWeight: 'bold', color: '#28bc10'}}>{selectedWithdrawal.amount} {selectedWithdrawal.currency}</span></div>
                                    <div><strong>Метод:</strong> {selectedWithdrawal.payment_method || '—'}</div>
                                    <div><strong>Банк:</strong> {selectedWithdrawal.bank_name || '—'}</div>
                                    <div><strong>ФИО для вывода:</strong> {selectedWithdrawal.fio || '—'}</div>
                                    <div><strong>Реквизиты:</strong></div>
                                    <div style={{ paddingLeft: '10px', fontSize: '13px' }}>
                                        {selectedWithdrawal.phone_number && <div>📱 {selectedWithdrawal.phone_number}</div>}
                                        {selectedWithdrawal.card_number && <div>💳 {selectedWithdrawal.card_number}</div>}
                                        {selectedWithdrawal.wallet && <div>👛 {selectedWithdrawal.wallet}</div>}
                                    </div>
                                    <div><strong>Дата создания:</strong> {new Date(selectedWithdrawal.created_at).toLocaleString('ru-RU')}</div>
                                    <div><strong>Статус:</strong> <span className={`status-${selectedWithdrawal.status.toLowerCase()}`}>{selectedWithdrawal.status}</span></div>
                                </div>
                            </div>

                            {/* Информация о пользователе */}
                            <div className="user-info-card">
                                <h3>👤 Информация о пользователе</h3>
                                <div className="user-info-fields">
                                    <div><strong>User ID:</strong> {selectedWithdrawal.user_id}</div>
                                    <div><strong>Email:</strong> {selectedWithdrawal.user_email || '—'}</div>
                                    <div><strong>Username:</strong> {selectedWithdrawal.username || '—'}</div>
                                    
                                    {/* Балансы пользователя */}
                                    <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #333' }}>
                                        <strong>💰 Балансы пользователя:</strong>
                                        <div style={{ marginTop: '5px', fontSize: '13px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px' }}>
                                            <div>💵 USD: ${parseFloat(selectedWithdrawal.balance_usd || 0).toFixed(2)}</div>
                                            <div>₽ RUB: ₽{parseFloat(selectedWithdrawal.balance_rub || 0).toFixed(2)}</div>
                                            <div>R$ BRL: R${parseFloat(selectedWithdrawal.balance_brl || 0).toFixed(2)}</div>
                                            <div>₮ USDT: ₮{parseFloat(selectedWithdrawal.balance_usdt || 0).toFixed(2)}</div>
                                            <div>€ EUR: €{parseFloat(selectedWithdrawal.balance_eur || 0).toFixed(2)}</div>
                                        </div>
                                        {(() => {
                                            const balanceField = `balance_${selectedWithdrawal.currency.toLowerCase()}`;
                                            const userBalance = parseFloat(selectedWithdrawal[balanceField] || 0);
                                            const withdrawAmount = parseFloat(selectedWithdrawal.amount);
                                            if (selectedWithdrawal.type !== 'referal' && selectedWithdrawal.type !== 'cpa' && userBalance < withdrawAmount) {
                                                return (
                                                    <div style={{ marginTop: '8px', padding: '8px', background: 'rgba(255, 68, 68, 0.15)', borderRadius: '6px', border: '1px solid #ff4444' }}>
                                                        <strong style={{ color: '#ff4444' }}>⚠️ Недостаточно средств!</strong>
                                                        <div style={{ fontSize: '12px', marginTop: '3px', color: '#ff9800' }}>
                                                            На балансе: {userBalance.toFixed(2)} {selectedWithdrawal.currency}, запрошено: {withdrawAmount.toFixed(2)}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })()}
                                    </div>
                                    
                                    <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #333' }}>
                                        <strong>ФИО при верификации:</strong>
                                        {selectedWithdrawal.first_name || selectedWithdrawal.last_name ? (
                                            <div style={{ marginTop: '5px', fontSize: '14px', color: selectedWithdrawal.verification_status === 'approved' ? '#28bc10' : '#999' }}>
                                                {selectedWithdrawal.last_name} {selectedWithdrawal.first_name} {selectedWithdrawal.middle_name || ''}
                                                <div style={{ fontSize: '11px', marginTop: '3px' }}>
                                                    {selectedWithdrawal.verification_status === 'approved' && '✅ Верификация пройдена'}
                                                    {selectedWithdrawal.verification_status === 'pending' && '⏳ На рассмотрении'}
                                                    {selectedWithdrawal.verification_status === 'rejected' && '❌ Отклонена'}
                                                    {!selectedWithdrawal.verification_status && '— Не подавалась'}
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={{ marginTop: '5px', fontSize: '13px', color: '#ff9800' }}>❌ Верификация не пройдена</div>
                                        )}
                                    </div>
                                    {selectedWithdrawal.fio && selectedWithdrawal.first_name && selectedWithdrawal.fio !== `${selectedWithdrawal.last_name} ${selectedWithdrawal.first_name} ${selectedWithdrawal.middle_name || ''}`.trim() && (
                                        <div style={{ marginTop: '10px', padding: '10px', background: 'rgba(255, 152, 0, 0.1)', borderRadius: '8px', border: '1px solid #ff9800' }}>
                                            <strong style={{ color: '#ff9800' }}>⚠️ ВНИМАНИЕ:</strong>
                                            <div style={{ fontSize: '13px', marginTop: '5px' }}>
                                                ФИО для вывода отличается от ФИО при верификации!
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Блок с комментарием и действиями */}
                        {selectedWithdrawal.status === 'WAITING' && (
                            <div style={{ marginTop: '20px' }}>
                                <h3>💬 Комментарий (необязательно для подтверждения, обязательно для отклонения)</h3>
                                
                                {/* Шаблонные причины для отклонения */}
                                <div style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', color: '#999' }}>Выберите шаблонную причину отклонения:</label>
                                    <select 
                                        className="prefs-input"
                                        onChange={(e) => setWithdrawalComment(e.target.value)}
                                        value={withdrawalComment}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    >
                                        <option value="">-- Выберите причину или напишите свою --</option>
                                        <option value="Имя владельца аккаунта отличается от имени владельца счёта для вывода">Имя владельца аккаунта отличается от имени владельца счёта для вывода</option>
                                        <option value="Недостаточно средств на балансе">Недостаточно средств на балансе</option>
                                        <option value="Некорректные реквизиты для вывода">Некорректные реквизиты для вывода</option>
                                        <option value="Не пройдена верификация аккаунта">Не пройдена верификация аккаунта</option>
                                        <option value="Подозрительная активность на аккаунте">Подозрительная активность на аккаунте</option>
                                        <option value="Нарушение правил платформы">Нарушение правил платформы</option>
                                    </select>
                                </div>

                                <textarea
                                    className="form-textarea w-full"
                                    placeholder="Введите комментарий или выберите шаблонную причину выше..."
                                    value={withdrawalComment}
                                    onChange={(e) => setWithdrawalComment(e.target.value)}
                                    rows={4}
                                    style={{ width: '100%', marginBottom: '15px' }}
                                />

                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                    {(() => {
                                        const balanceField = `balance_${selectedWithdrawal.currency.toLowerCase()}`;
                                        const userBalance = parseFloat(selectedWithdrawal[balanceField] || 0);
                                        const withdrawAmount = parseFloat(selectedWithdrawal.amount);
                                        const hasInsufficientFunds = selectedWithdrawal.type !== 'referal' && selectedWithdrawal.type !== 'cpa' && userBalance < withdrawAmount;
                                        
                                        return (
                                            <>
                                                <button
                                                    onClick={handleWithdrawalApprove}
                                                    disabled={withdrawalProcessing || hasInsufficientFunds}
                                                    className="btn-success"
                                                    style={{ 
                                                        padding: '12px 24px', 
                                                        fontSize: '16px', 
                                                        fontWeight: 'bold',
                                                        opacity: hasInsufficientFunds ? 0.5 : 1,
                                                        cursor: hasInsufficientFunds ? 'not-allowed' : 'pointer'
                                                    }}
                                                    title={hasInsufficientFunds ? 'Недостаточно средств на балансе пользователя' : ''}
                                                >
                                                    {withdrawalProcessing ? '⏳ Обработка...' : '✅ Подтвердить вывод'}
                                                </button>
                                                <button
                                                    onClick={handleWithdrawalDeny}
                                                    disabled={withdrawalProcessing}
                                                    className="btn-danger"
                                                    style={{ padding: '12px 24px', fontSize: '16px', fontWeight: 'bold' }}
                                                >
                                                    {withdrawalProcessing ? '⏳ Обработка...' : '❌ Отклонить вывод'}
                                                </button>
                                            </>
                                        );
                                    })()}
                                </div>
                            </div>
                        )}

                        {/* Если заявка уже обработана */}
                        {selectedWithdrawal.status !== 'WAITING' && (
                            <div style={{ marginTop: '20px', padding: '15px', background: 'rgba(100, 100, 100, 0.1)', borderRadius: '8px' }}>
                                <h3>📋 Статус заявки</h3>
                                <p><strong>Статус:</strong> <span className={`status-${selectedWithdrawal.status.toLowerCase()}`}>{selectedWithdrawal.status}</span></p>
                                {selectedWithdrawal.admin_comment && (
                                    <>
                                        <p><strong>Комментарий администратора:</strong></p>
                                        <div style={{ padding: '10px', background: 'rgba(150, 150, 150, 0.1)', borderRadius: '8px', marginTop: '5px' }}>
                                            {selectedWithdrawal.admin_comment}
                                        </div>
                                    </>
                                )}
                                {selectedWithdrawal.admin_email && (
                                    <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                        Обработал: {selectedWithdrawal.admin_username || selectedWithdrawal.admin_email}
                                    </p>
                                )}
                            </div>
                        )}

                        <button onClick={closeWithdrawalModal} className="mt-6" style={{ width: '100%' }}>
                            Закрыть
                        </button>
                    </div>
                </div>
            )}

            <div ref={paymentsRef} className="prefs-section">
                <h2>Все платежи</h2>
                <input type="date" className="prefs-input" value={paymentDates.from} onChange={e => setPaymentDates({ ...paymentDates, from: e.target.value })} />
                <input type="date" className="prefs-input" value={paymentDates.to} onChange={e => setPaymentDates({ ...paymentDates, to: e.target.value })} />
                <button onClick={() => setPaymentPage(1)}>Обновить</button>

                <div className="prefs-table-wrapper">
                    <table className="prefs-table">
                        <thead>
                            <tr><th>ID</th><th>Дата</th><th>Email</th><th>Сумма</th><th>Валюта</th><th>Статус</th><th>Действия</th></tr>
                        </thead>
                        <tbody>
                            {payments.map(p => (
                                <tr key={p.id}>
                                    <td>{p.id}</td>
                                    <td>{new Date(p.created_at).toLocaleString()}</td>
                                    <td>{p.email}</td>
                                    <td>{p.amount}</td>
                                    <td>{p.currency}</td>
                                    <td className={`status-${p.status.toLowerCase()}`}>{p.status}</td>
                                    <td>
                                        {(p.status === 'pending' || p.status === 'CLIENTPAID') && (
                                            <button
                                                onClick={() => confirmPayment(p.id)}
                                                className="confirm-btn"
                                            >
                                                Подтвердить
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <button onClick={() => setPaymentPage(Math.max(1, paymentPage - 1))}>Пред</button>
                <span>Страница {paymentPage}</span>
                <button onClick={() => setPaymentPage(paymentPage + 1)}>След</button>
            </div>

            {/* Секция верификации */}
            <div ref={verificationRef} className="prefs-section">
                <h2>Верификация аккаунтов</h2>

                <div className="mb-6">
                    <div className="form-row">
                        <div className="form-group">
                            <label className="form-label">Фильтр по статусу:</label>
                            <select
                                value={verificationStatus}
                                onChange={(e) => setVerificationStatus(e.target.value)}
                                className="form-select"
                            >
                                <option value="">Все</option>
                                <option value="pending">На рассмотрении</option>
                                <option value="approved">Одобрены</option>
                                <option value="rejected">Отклонены</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="prefs-table-wrapper">
                    <table className="prefs-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Пользователь</th>
                                <th>ФИО</th>
                                <th>Дата рождения</th>
                                <th>Статус</th>
                                <th>Дата подачи</th>
                                <th>Действия</th>
                            </tr>
                        </thead>
                        <tbody>
                            {verificationRequests.map((request) => (
                                <tr key={request.id}>
                                    <td>{request.id.substr(0, 8)}</td>
                                    <td>
                                        {request.username}<br />
                                        <small>{request.email}</small>
                                    </td>
                                    <td>
                                        {request.last_name} {request.first_name}
                                        {request.middle_name && ` ${request.middle_name}`}
                                    </td>
                                    <td>{new Date(request.birth_date).toLocaleDateString('ru-RU')}</td>
                                    <td>
                                        <span className={`status ${request.status}`}>
                                            {request.status === 'pending' && '⏳ На рассмотрении'}
                                            {request.status === 'approved' && '✅ Одобрена'}
                                            {request.status === 'rejected' && '❌ Отклонена'}
                                        </span>
                                    </td>
                                    <td>{formatDate(request.created_at)}</td>
                                    <td>
                                        <button
                                            onClick={() => openVerificationModal(request)}
                                            className="mr-1"
                                        >
                                            👁️ Просмотр
                                        </button>
                                        {request.status === 'pending' && (
                                            <>
                                                <button
                                                    onClick={() => handleVerificationAction(request.id, 'approved')}
                                                    className="btn-success mr-1"
                                                >
                                                    ✅ Одобрить
                                                </button>
                                                <button
                                                    onClick={() => openVerificationModal(request)}
                                                    className="btn-danger"
                                                >
                                                    ❌ Отклонить
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <button onClick={() => setVerificationPage(Math.max(1, verificationPage - 1))}>Пред</button>
                <span>Страница {verificationPage}</span>
                <button onClick={() => setVerificationPage(verificationPage + 1)}>След</button>
            </div>

            {/* Модальное окно для просмотра заявки на верификацию */}
            {selectedVerificationRequest && (
                <div className="verification-modal-overlay" onClick={closeVerificationModal}>
                    <div className="verification-modal-content" onClick={(e) => e.stopPropagation()}>
                        <h3>Заявка на верификацию</h3>

                        <div className="verification-modal-grid">
                            <div>
                                <h4>Информация о пользователе</h4>
                                <p><strong>Пользователь:</strong> {selectedVerificationRequest.username}</p>
                                <p><strong>Email:</strong> {selectedVerificationRequest.email}</p>
                                <p><strong>ФИО:</strong> {selectedVerificationRequest.last_name} {selectedVerificationRequest.first_name} {selectedVerificationRequest.middle_name}</p>
                                <p><strong>Дата рождения:</strong> {new Date(selectedVerificationRequest.birth_date).toLocaleDateString('ru-RU')}</p>
                                <p><strong>Статус:</strong>
                                    <span className={`status ${selectedVerificationRequest.status}`}>
                                        {selectedVerificationRequest.status === 'pending' && ' На рассмотрении'}
                                        {selectedVerificationRequest.status === 'approved' && ' Одобрена'}
                                        {selectedVerificationRequest.status === 'rejected' && ' Отклонена'}
                                    </span>
                                </p>
                                <p><strong>Дата подачи:</strong> {formatDate(selectedVerificationRequest.created_at)}</p>
                                {selectedVerificationRequest.reviewed_by_username && (
                                    <p><strong>Проверил:</strong> {selectedVerificationRequest.reviewed_by_username}</p>
                                )}
                            </div>

                            <div>
                                <h4>Документы</h4>
                                <div className="verification-doc-section">
                                    <div>
                                        <p><strong>Фото документа:</strong></p>
                                        {selectedVerificationRequest.document_photo_path && (
                                            <img
                                                src={`${API_URL}/api/admin/verification/photo/${selectedVerificationRequest.document_photo_path.split('/').pop()}`}
                                                alt="Документ"
                                                className="max-w-xs max-h-40 object-cover cursor-pointer"
                                                onClick={() => window.open(`${API_URL}/api/admin/verification/photo/${selectedVerificationRequest.document_photo_path.split('/').pop()}`, '_blank')}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        <p><strong>Селфи с документом:</strong></p>
                                        {selectedVerificationRequest.selfie_photo_path && (
                                            <img
                                                src={`${API_URL}/api/admin/verification/photo/${selectedVerificationRequest.selfie_photo_path.split('/').pop()}`}
                                                alt="Селфи"
                                                className="max-w-xs max-h-40 object-cover cursor-pointer"
                                                onClick={() => window.open(`${API_URL}/api/admin/verification/photo/${selectedVerificationRequest.selfie_photo_path.split('/').pop()}`, '_blank')}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {selectedVerificationRequest.admin_comment && (
                            <div className="mb-6">
                                <h4>Комментарий администратора</h4>
                                <div className="verification-comment-section">
                                    {selectedVerificationRequest.admin_comment}
                                </div>
                            </div>
                        )}

                        {selectedVerificationRequest.status === 'pending' && (
                            <div className="verification-actions-section">
                                <h4>Действия</h4>
                                <textarea
                                    placeholder="Комментарий (необязательно)"
                                    value={verificationComment}
                                    onChange={(e) => setVerificationComment(e.target.value)}
                                    className="form-textarea w-full"
                                />
                                <div className="verification-actions-buttons">
                                    <button
                                        onClick={() => handleVerificationAction(selectedVerificationRequest.id, 'approved', verificationComment)}
                                        className="btn-success"
                                    >
                                        ✅ Одобрить
                                    </button>
                                    <button
                                        onClick={() => handleVerificationAction(selectedVerificationRequest.id, 'rejected', verificationComment)}
                                        className="btn-danger"
                                    >
                                        ❌ Отклонить
                                    </button>
                                </div>
                            </div>
                        )}

                        <button onClick={closeVerificationModal} className="mt-6">
                            Закрыть
                        </button>
                    </div>
                </div>
            )}


            {/* Промокоды */}
            <div ref={promoCodesRef} className="prefs-section">
                <h2>Промокоды</h2>
                <button onClick={() => setShowPromoForm(!showPromoForm)}>
                    {showPromoForm ? "Скрыть форму" : "Создать промокод"}
                </button>
                
                {showPromoForm && (
                    <form onSubmit={handlePromoFormSubmit} className="mt-10">
                        <div className="promo-form-grid">
                    <input
                        type="text"
                                placeholder="Код (WELCOME100)"
                                value={promoFormData.code}
                                onChange={(e) => setPromoFormData({ ...promoFormData, code: e.target.value })}
                                required
                                className="form-input w-full"
                            />
                            <input
                                type="datetime-local"
                                placeholder="Истекает"
                                value={promoFormData.expiresAt}
                                onChange={(e) => setPromoFormData({ ...promoFormData, expiresAt: e.target.value })}
                                className="form-input w-full"
                            />
                            <input
                                type="number"
                                placeholder="Мин. депозит"
                                value={promoFormData.minDeposit}
                                onChange={(e) => setPromoFormData({ ...promoFormData, minDeposit: e.target.value })}
                                className="form-input w-full"
                            />
                            <input
                                type="number"
                                placeholder="Лимит активаций"
                                value={promoFormData.usageLimit}
                                onChange={(e) => setPromoFormData({ ...promoFormData, usageLimit: e.target.value })}
                                className="form-input w-full"
                            />
                            <input
                                type="number"
                                placeholder="Лимит на игрока"
                                value={promoFormData.perUserLimit}
                                onChange={(e) => setPromoFormData({ ...promoFormData, perUserLimit: e.target.value })}
                                className="form-input w-full"
                            />
                            <input
                                type="number"
                                placeholder="Бонус %"
                                value={promoFormData.bonusPercent}
                                onChange={(e) => setPromoFormData({ ...promoFormData, bonusPercent: e.target.value })}
                                className="form-input w-full"
                            />
                            <input
                                type="number"
                                placeholder="Макс. бонус"
                                value={promoFormData.bonusMaxAmount}
                                onChange={(e) => setPromoFormData({ ...promoFormData, bonusMaxAmount: e.target.value })}
                                className="form-input w-full"
                            />
                            <input
                                type="number"
                                placeholder="Фриспины"
                                value={promoFormData.freeSpinsCount}
                                onChange={(e) => setPromoFormData({ ...promoFormData, freeSpinsCount: e.target.value })}
                                className="form-input w-full"
                            />
                            <select
                                value={promoFormData.bonusType}
                                onChange={(e) => setPromoFormData({ ...promoFormData, bonusType: e.target.value })}
                                className="form-select w-full"
                            >
                                <option value="bonus">Бонус</option>
                                <option value="freespins">Фриспины</option>
                                <option value="mixed">Смешанный</option>
                            </select>
                            <input
                                type="text"
                                placeholder="Партнёр/Стример"
                                value={promoFormData.partnerCode}
                                onChange={(e) => setPromoFormData({ ...promoFormData, partnerCode: e.target.value })}
                                className="form-input w-full"
                            />
                </div>
                        <textarea
                            placeholder="Условия промокода"
                            value={promoFormData.conditions}
                            onChange={(e) => setPromoFormData({ ...promoFormData, conditions: e.target.value })}
                            className="form-textarea w-full mt-10"
                            style={{ minHeight: 60 }}
                        />
                        <button type="submit" className="mt-10">Создать промокод</button>
                    </form>
                )}

                <div className="prefs-table-wrapper">
                    <table className="prefs-table">
                        <thead>
                            <tr>
                                <th>Код</th>
                                <th>Статус</th>
                                <th>Тип</th>
                                <th>Истекает</th>
                                <th>Мин. депозит</th>
                                <th>Бонус %</th>
                                <th>Макс. бонус</th>
                                <th>Фриспины</th>
                                <th>Использовано / Лимит</th>
                                <th>Уникальных игроков</th>
                                <th>Выдано фриспинов</th>
                                <th>Выдано бонусов</th>
                                <th>Партнёр</th>
                                <th>Создан</th>
                                <th>Действия</th>
                            </tr>
                        </thead>
                        <tbody>
                            {promoCodes.map(promo => {
                                const stats = promoCodesStats.find(s => s.id === promo.id);
                                return (
                                    <tr key={promo.id}>
                                        <td className="font-bold">{promo.code}</td>
                                        <td>
                                            <span className={promo.is_active ? 'color-green' : 'color-red'}>
                                                {promo.is_active ? 'Активен' : 'Неактивен'}
                                            </span>
                                    </td>
                                        <td>
                                            {promo.bonus_type === 'bonus' ? '💰 Бонус' : 
                                             promo.bonus_type === 'freespins' ? '🎰 Фриспины' : 
                                             '🎁 Смешанный'}
                                    </td>
                                    <td>
                                            {promo.expires_at ? new Date(promo.expires_at).toLocaleString() : 'Бессрочно'}
                                    </td>
                                        <td>{promo.min_deposit}₽</td>
                                        <td>{promo.bonus_percent}%</td>
                                        <td>{promo.bonus_max_amount}₽</td>
                                        <td>{promo.free_spins_count}</td>
                                        <td>
                                            <strong>{promo.usage_count}</strong> / {promo.usage_limit || '∞'}
                                            {stats && stats.used_activations !== promo.usage_count && (
                                                <div className="font-size-xs color-orange">
                                                    (Активаций: {stats.used_activations})
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            <strong className="color-blue">
                                                {stats ? stats.unique_users : '—'}
                                            </strong>
                                        </td>
                                        <td>
                                            <strong className="color-purple">
                                                {stats ? stats.total_freespins_awarded : '—'}
                                            </strong>
                                        </td>
                                        <td>
                                            <strong className="text-green-600">
                                                {stats ? Number(stats.total_bonuses_awarded).toFixed(2) + ' ₽' : '—'}
                                            </strong>
                                        </td>
                                        <td>{promo.partner_code || '—'}</td>
                                        <td>{new Date(promo.created_at).toLocaleDateString()}</td>
                                        <td>
                                            <div className="promo-actions">
                                            {promo.is_active ? (
                                                    <button onClick={() => handlePromoAction(promo.id, 'deactivate')} className="promo-action-btn">
                                                    🚫 Деактивировать
                                                </button>
                                            ) : (
                                                    <button onClick={() => handlePromoAction(promo.id, 'activate')} className="promo-action-btn">
                                                    ✅ Активировать
                                                </button>
                                            )}
                                                <button onClick={() => handlePromoAction(promo.id, 'delete')} className="promo-delete-btn">
                                                🗑️ Удалить
                                            </button>
                                            </div>
                                    </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <button onClick={() => setPromoPage(Math.max(1, promoPage - 1))}>Пред</button>
                <span>Страница {promoPage}</span>
                <button onClick={() => setPromoPage(promoPage + 1)}>След</button>
                </div>


            {/* Таблица всех транзакций */}
            <div ref={transactionsRef} className="prefs-section">
                <h2>Все транзакции</h2>
                
                {/* Фильтры */}
                <div className="transaction-filters">
                    <h3>🔍 Фильтры</h3>
                    <div className="filter-grid">
                        <div className="filter-item">
                            <label>Тип транзакции:</label>
                            <select
                                value={transactionFilters.transaction_type}
                                onChange={(e) => setTransactionFilters({...transactionFilters, transaction_type: e.target.value})}
                                className="form-select w-full"
                            >
                                <option value="">Все типы</option>
                                {availableFilters.transactionTypes.map(type => (
                                    <option key={type} value={type}>{type}</option>
                                ))}
                            </select>
                        </div>
                        
                        <div className="filter-item">
                            <label>Валюта:</label>
                            <select
                                value={transactionFilters.currency}
                                onChange={(e) => setTransactionFilters({...transactionFilters, currency: e.target.value})}
                                className="form-select w-full"
                            >
                                <option value="">Все валюты</option>
                                {availableFilters.currencies.map(currency => (
                                    <option key={currency} value={currency}>{currency}</option>
                                ))}
                            </select>
                        </div>
                        
                        <div className="filter-item">
                            <label>ID пользователя:</label>
                            <input
                                type="number"
                                value={transactionFilters.user_id}
                                onChange={(e) => setTransactionFilters({...transactionFilters, user_id: e.target.value})}
                                placeholder="ID пользователя"
                                className="form-input w-full"
                            />
                        </div>
                        
                        <div className="filter-item">
                            <label>Дата от:</label>
                            <input
                                type="datetime-local"
                                value={transactionFilters.date_from}
                                onChange={(e) => setTransactionFilters({...transactionFilters, date_from: e.target.value})}
                                className="form-input w-full"
                            />
                        </div>
                        
                        <div className="filter-item">
                            <label>Дата до:</label>
                            <input
                                type="datetime-local"
                                value={transactionFilters.date_to}
                                onChange={(e) => setTransactionFilters({...transactionFilters, date_to: e.target.value})}
                                className="form-input w-full"
                            />
                        </div>
                        
                        <div className="filter-item">
                            <label>Мин. сумма:</label>
                            <input
                                type="number"
                                step="0.01"
                                value={transactionFilters.min_amount}
                                onChange={(e) => setTransactionFilters({...transactionFilters, min_amount: e.target.value})}
                                placeholder="0.00"
                                className="form-input w-full"
                            />
                        </div>
                        
                        <div className="filter-item">
                            <label>Макс. сумма:</label>
                            <input
                                type="number"
                                step="0.01"
                                value={transactionFilters.max_amount}
                                onChange={(e) => setTransactionFilters({...transactionFilters, max_amount: e.target.value})}
                                placeholder="0.00"
                                className="form-input w-full"
                            />
                        </div>
                    </div>
                    
                    <div className="filter-buttons">
                    <button 
                            onClick={() => {setAllTransactionsPage(1); fetchAllTransactions();}}
                            className="filter-button"
                    >
                            🔍 Применить фильтры
                    </button>
                        <button 
                            onClick={resetTransactionFilters}
                            className="filter-button"
                        >
                            🗑️ Сбросить
                        </button>
                    </div>
                </div>

                {/* Таблица транзакций */}
                {allTransactionsLoading ? (
                    <p>Загрузка транзакций...</p>
                ) : (
                    <>
                        <div className="transaction-info">
                            Показано {allTransactions.length} из {allTransactionsPagination.totalTransactions} транзакций
                        </div>
                        
                        <div className="prefs-table-wrapper">
                            <table className="prefs-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Пользователь</th>
                                        <th>Тип</th>
                                        <th>Сумма</th>
                                        <th>Валюта</th>
                                        <th>Новый баланс</th>
                                        <th>Дата</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allTransactions.map(transaction => (
                                        <tr key={transaction.id}>
                                            <td>{transaction.id}</td>
                                            <td>
                                                <div>
                                                    <div className="user-id-bold">ID: {transaction.user_id}</div>
                                                    <div className="user-detail-text">
                                                        {transaction.email || '—'}
                                                    </div>
                                                    {transaction.username && (
                                                        <div className="user-detail-text">
                                                            @{transaction.username}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`transaction-type-badge ${
                                                    transaction.transaction_type === 'DEPOSIT' ? 'transaction-type-deposit' :
                                                    transaction.transaction_type === 'WITHDRAWAL' ? 'transaction-type-withdrawal' :
                                                    transaction.transaction_type === 'CASHBACK' ? 'transaction-type-cashback' :
                                                    transaction.transaction_type === 'RAKEBACK' ? 'transaction-type-rakeback' :
                                                    transaction.transaction_type === 'BONUS' ? 'transaction-type-bonus' :
                                                    transaction.transaction_type === 'BONUS_SPENT' ? 'transaction-type-bonus-spent' :
                                                    'transaction-type-default'
                                                }`}>
                                                    {transaction.transaction_type}
                    </span>
                                            </td>
                                            <td className={transaction.amount >= 0 ? 'transaction-amount-positive' : 'transaction-amount-negative'}>
                                                {transaction.amount >= 0 ? '+' : ''}{Number(transaction.amount).toFixed(2)}
                                            </td>
                                            <td>{transaction.currency}</td>
                                            <td>{Number(transaction.new_balance).toFixed(2)}</td>
                                            <td>{formatDate(transaction.created_at)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Пагинация */}
                        {allTransactionsPagination.totalPages > 1 && (
                            <div className="pagination-controls">
                    <button 
                                    onClick={() => setAllTransactionsPage(Math.max(1, allTransactionsPage - 1))}
                                    disabled={!allTransactionsPagination.hasPrev}
                                >
                                    ← Предыдущая
                                </button>
                                
                                <span>
                                    Страница {allTransactionsPagination.currentPage} из {allTransactionsPagination.totalPages}
                                </span>
                                
                                <button 
                                    onClick={() => setAllTransactionsPage(allTransactionsPage + 1)}
                                    disabled={!allTransactionsPagination.hasNext}
                                >
                                    Следующая →
                    </button>
                </div>
                        )}
                    </>
                )}
            </div>

            {/* Раздел CPA партнёров */}
            <div ref={cpaPartnersRef} className="prefs-section">
                <h2>💼 CPA Партнёры</h2>
                
                {selectedCpaPartner ? (
                    <div>
                        <button 
                            onClick={() => {
                                setSelectedCpaPartner(null);
                                setCpaPartnerDetails(null);
                            }}
                            style={{ marginBottom: '20px', padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#667eea', color: '#fff', cursor: 'pointer' }}
                        >
                            ← Назад к списку
                        </button>
                        
                        {cpaPartnerDetails ? (
                            <div>
                                <h3>Детали CPA партнёра</h3>
                                <div style={{ marginBottom: '20px', padding: '16px', background: '#23232e', borderRadius: '8px' }}>
                                    <div><strong>ID:</strong> {cpaPartnerDetails.partner.id}</div>
                                    <div><strong>Email:</strong> {cpaPartnerDetails.partner.email}</div>
                                    <div><strong>Username:</strong> {cpaPartnerDetails.partner.username || '—'}</div>
                                    <div><strong>Ставка:</strong> ${cpaPartnerDetails.partner.cpaRate}</div>
                                    <div><strong>Дата регистрации:</strong> {new Date(cpaPartnerDetails.partner.createdAt).toLocaleString()}</div>
                                </div>
                                
                                <h4>Общая статистика</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '20px' }}>
                                    <div style={{ padding: '16px', background: '#23232e', borderRadius: '8px' }}>
                                        <div style={{ fontSize: '14px', color: '#999', marginBottom: '8px' }}>Всего пользователей</div>
                                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#fff' }}>{cpaPartnerDetails.stats.totalUsers}</div>
                                    </div>
                                    <div style={{ padding: '16px', background: '#23232e', borderRadius: '8px' }}>
                                        <div style={{ fontSize: '14px', color: '#999', marginBottom: '8px' }}>С депозитами</div>
                                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#fff' }}>{cpaPartnerDetails.stats.usersWithDeposits}</div>
                                    </div>
                                    <div style={{ padding: '16px', background: '#23232e', borderRadius: '8px' }}>
                                        <div style={{ fontSize: '14px', color: '#999', marginBottom: '8px' }}>Без выплаты</div>
                                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#fff' }}>{cpaPartnerDetails.stats.usersWithoutPayout}</div>
                                    </div>
                                    <div style={{ padding: '16px', background: '#23232e', borderRadius: '8px' }}>
                                        <div style={{ fontSize: '14px', color: '#999', marginBottom: '8px' }}>Доступно к выплате</div>
                                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#28bc10' }}>${cpaPartnerDetails.stats.totalEarnings.toFixed(2)}</div>
                                    </div>
                                </div>
                                
                                <h4>Привлечённые пользователи</h4>
                                <div className="prefs-table-wrapper">
                                    <table className="prefs-table">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Email</th>
                                                <th>Дата регистрации</th>
                                                <th>Депозитов</th>
                                                <th>Сумма депозитов</th>
                                                <th>Выплата получена</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cpaPartnerDetails.users.map((user) => (
                                                <tr key={user.id}>
                                                    <td>{user.id}</td>
                                                    <td>{user.email}</td>
                                                    <td>{new Date(user.created_at).toLocaleDateString()}</td>
                                                    <td>{user.depositCount}</td>
                                                    <td>
                                                        {Object.entries(user.depositsByCurrency || {}).map(([cur, data]) => (
                                                            <div key={cur}>{data.total.toFixed(2)} {cur}</div>
                                                        ))}
                                                        {user.depositCount === 0 && <span style={{ color: '#999' }}>Нет депозитов</span>}
                                                    </td>
                                                    <td>
                                                        {user.hasPayout ? (
                                                            <span style={{ color: '#28bc10' }}>✓ Да</span>
                                                        ) : (
                                                            <span style={{ color: user.hasDeposit ? '#ffb300' : '#999' }}>
                                                                {user.hasDeposit ? 'Нет' : 'Нет депозита'}
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                
                                {cpaPartnerDetails.withdrawals && cpaPartnerDetails.withdrawals.length > 0 && (
                                    <>
                                        <h4 style={{ marginTop: '30px' }}>История выплат</h4>
                                        <div className="prefs-table-wrapper">
                                            <table className="prefs-table">
                                                <thead>
                                                    <tr>
                                                        <th>ID заявки</th>
                                                        <th>Сумма</th>
                                                        <th>Валюта</th>
                                                        <th>Пользователей</th>
                                                        <th>Статус</th>
                                                        <th>Дата создания</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {cpaPartnerDetails.withdrawals.map((w) => (
                                                        <tr key={w.id}>
                                                            <td>{w.ext_id}</td>
                                                            <td>{w.amount}</td>
                                                            <td>{w.currency}</td>
                                                            <td>{w.users_count}</td>
                                                            <td>
                                                                <span style={{
                                                                    color: w.status === 'SUCCESSFUL' ? '#28bc10' : 
                                                                           w.status === 'DENIED' ? '#ff4b4b' : '#ffb300'
                                                                }}>
                                                                    {w.status === 'SUCCESSFUL' ? 'Выплачено' : 
                                                                     w.status === 'DENIED' ? 'Отклонено' : 'Ожидание'}
                                                                </span>
                                                            </td>
                                                            <td>{new Date(w.created_at).toLocaleString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div>Загрузка деталей...</div>
                        )}
                    </div>
                ) : (
                    <div>
                        <div className="prefs-table-wrapper">
                            <table className="prefs-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Email</th>
                                        <th>Username</th>
                                        <th>Ставка</th>
                                        <th>Дата регистрации</th>
                                        <th>Действия</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cpaPartners.length > 0 ? (
                                        cpaPartners.map((partner) => (
                                            <tr key={partner.id}>
                                                <td>{partner.id}</td>
                                                <td>{partner.email}</td>
                                                <td>{partner.username || '—'}</td>
                                                <td>${partner.cpa_rate}</td>
                                                <td>{new Date(partner.created_at).toLocaleDateString()}</td>
                                                <td>
                                                    <button
                                                        onClick={async () => {
                                                            setSelectedCpaPartner(partner.id);
                                                            await fetchCPAPartnerDetails(partner.id);
                                                        }}
                                                        style={{ padding: '6px 12px', borderRadius: '6px', border: 'none', background: '#667eea', color: '#fff', cursor: 'pointer' }}
                                                    >
                                                        Просмотр
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                                Нет CPA партнёров
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

        </div>
    );
};

export default Prefs1;
